export default function SyenovixLogo({ height = 32, showTagline = false, dark = false }) {
  const color = dark ? '#a5c8e4' : '#1a3a5c';
  const tagColor = dark ? '#6fa8c8' : '#4a7fa5';

  return (
    <svg
      viewBox={showTagline ? '0 0 200 42' : '0 0 200 30'}
      height={height}
      style={{ display: 'block' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="0"
        y="26"
        fontFamily="'Plus Jakarta Sans','Inter',sans-serif"
        fontSize="26"
        fontWeight="800"
        letterSpacing="-0.5"
        fill={color}
      >
        Syenovix
      </text>

      {showTagline && (
        <text
          x="1"
          y="38"
          fontFamily="'Inter',sans-serif"
          fontSize="7"
          fontWeight="500"
          letterSpacing="2.5"
          fill={tagColor}
        >
          INTELLIGENCE. INNOVATION. EVOLUTION.
        </text>
      )}
    </svg>
  );
}
